Kubrick.Counter = {
  // Duration between counts
  WAIT: 10000,

  // Active class
  CLASS_ACTIVE: "counter-active",

  // Default animation
  ANIM_DURATION: 1000,

  //
  _selector_counter: ".page-content .block .counter",
  _selector_item: ".item",
  _selector_target: ".counter-target",
  _selector_block: ".block",
  _selector_count_pos: "data-counter-position",
  _selector_duration: "data-counter-duration",
  _selector_breakpoint: "data-breakpoints",

  // Controller cache
  _controllers: [],
  _configs: [],

  start: function(config) {
    Kubrick._log("Counter: Configuring...", config);
    var $BLOCK = document.querySelector("#content ." + config.id);
    var $COUNTER = $BLOCK.querySelector(this._selector_counter);
    this._setupCounter($BLOCK, $COUNTER);
    window.addEventListener("resize", this._checkControllers.bind(this));
    this._checkControllers();
  },

  _checkControllers: function(e) {
    for (let i = 0; i < this._controllers.length; i++) {
      let controller = this._controllers[i];
      if (
        window.getComputedStyle(controller.$COUNTER, null).display !== "none"
      ) {
        this.startCounter(controller);
      } else {
        this.stopCounter(controller);
      }
    }
  },

  _setupCounter: function($BLOCK, $COUNTER) {
    var controller = {
      $BLOCK: $BLOCK,
      $COUNTER: $COUNTER,
      $ITEMS: $COUNTER.querySelectorAll(this._selector_item),
      DURATION: $COUNTER.getAttribute(this._selector_duration) || this.WAIT,
      timeoutID: false
    };

    // Find targets
    controller.$TARGETS = $BLOCK.querySelectorAll(
      this._selector_target + " [" + this._selector_count_pos + "]"
    );

    // Append first active states
    if (controller.$ITEMS.length) {
      controller.$ITEMS[0].classList.add(this.CLASS_ACTIVE);
    }
    if (controller.$TARGETS.length) {
      controller.$TARGETS[0].classList.add(this.CLASS_ACTIVE);
    }

    // Add click handlers
    for (let i = 0; i < controller.$ITEMS.length; i++) {
      controller.$ITEMS[i].addEventListener(
        "click",
        function(e) {
          // Get active item
          var $ACTIVEITEM = controller.$COUNTER.querySelector(
            this._selector_item + "." + this.CLASS_ACTIVE
          );

          // Get clicked item
          var $CLICKEDITEM = e.target;

          // Manually stop counter
          this.stopCounter(controller);

          // Display item
          this._displayItem($ACTIVEITEM, $CLICKEDITEM, controller);
        }.bind(this)
      );
    }
    // Set first active items
    this._controllers.push(controller);
  },

  startCounter: function(controller, restart) {
    if (controller.timeoutID == false && controller.$TARGETS.length) {
      if (!restart) {
        Kubrick._log("Counter: Starting...", controller);
      }
      controller.timeoutID = setTimeout(
        this._displayNextItem.bind(this),
        controller.DURATION,
        controller
      );
    }
  },

  stopCounter: function(controller) {
    if (controller.timeoutID !== false) {
      Kubrick._log("Counter: Stopping...", controller);
      clearTimeout(controller.timeoutID);
      controller.timeoutID = false;
    }
  },

  _displayNextItem: function(controller) {
    var $ACTIVEITEM = controller.$COUNTER.querySelector(
      this._selector_item + "." + this.CLASS_ACTIVE
    );

    var $NEXTITEM = $ACTIVEITEM.nextElementSibling;
    if (!$NEXTITEM) {
      $NEXTITEM = controller.$ITEMS[0];
    }

    // Display
    this._displayItem($ACTIVEITEM, $NEXTITEM, controller);
  },

  _displayItem: function($ACTIVEITEM, $NEXTITEM, controller) {
    $ACTIVEITEM.classList.remove(this.CLASS_ACTIVE);
    $NEXTITEM.classList.toggle(this.CLASS_ACTIVE);

    // Find targets
    // Remove old active
    for (let a = 0; a < controller.$TARGETS.length; a++) {
      controller.$TARGETS[a].classList.remove(this.CLASS_ACTIVE);
    }

    // Append new active
    var $NEWTARGET = controller.$BLOCK.querySelector(
      this._selector_target +
        " [" +
        this._selector_count_pos +
        "='" +
        $NEXTITEM.getAttribute(this._selector_count_pos) +
        "']"
    );
    $NEWTARGET.classList.add(this.CLASS_ACTIVE);

    // See if AOS is used anywhere. If not, use a basic animation
    let aos_class = "aos-animate";
    let aos = $NEWTARGET.querySelectorAll("." + aos_class);

    // Animate
    anime({
      targets: $NEWTARGET,
      opacity: [0, 1],
      easing: Kubrick.EASING.NORMAL,
      duration: this.ANIM_DURATION
    });

    // Restart timer
    controller.timeoutID = false;
    this.startCounter(controller, true);
  }
};
